export const HomeOwnerFilterModalStyles = () => {
    return {
        modal: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '45vw',
            height: '50vh',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            outline: 'none',
            borderRadius: '1rem',
            padding: '0px !important',
            alignItems: 'center',
            justifyContent: 'center',
          },
          searchButton: {
            backgroundImage: 'linear-gradient(263deg, #ff6e00 43%, #ff9e54 91%)',
            color: 'white',
            fontSize: '12px',
            borderRadius: '1rem',
            textTransform: 'none',
            paddingLeft: '1rem',
            paddingRight: '1rem',
          }
    }
}